import { Color } from '@tmh-website/shared/colors';
import StyledTypo from '@tmh-website/styles/typo';
import styled, { css } from 'styled-components';

export const Headline = styled(StyledTypo.Typography)<{ $isLink?: boolean }>`
  color: ${props => props.theme.color[Color.Neutral_0_White]};
  transition: opacity ${props => props.theme.transitionTiming};

  ${props =>
    props.$isLink &&
    css`
      &:hover {
        text-decoration: none;
        opacity: 0.6;
      }

      &:active {
        opacity: 0.4;
      }
    `};
`;

export const Ul = styled.ul`
  padding: 0;
  margin: 0;
  list-style: none;
`;

export const SiteLink = styled.a`
  ${StyledTypo.uiTextCss};
  display: inline-block;
  padding: 6px 0;

  // We need to set line height to distinguish line breaks from next link
  line-height: ${props => props.theme.lineHeight.medium};
  color: ${props => props.theme.color[Color.Neutral_0_White]};
  opacity: 0.6;
  transition: opacity ${props => props.theme.transitionTiming};

  &:hover {
    text-decoration: none;
    opacity: 0.8;
  }
`;
